import { Component, Input, OnInit, EventEmitter, Output, ViewChild, ElementRef, Directive, AfterContentInit } from '@angular/core';
import { constants } from '../../utitlity/constant';
import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';
declare let $: any;
@Component({
    selector: "phone-input",
    template: require('./phone.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PhoneComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() questions: any = [];
    @Input() form: NgForm;
    @Input() prefillData: any = {};
    phoneCodeModel: any;
    @ViewChild("phInput", { read: ElementRef }) phInput: ElementRef;
    isLeadFormApplication: boolean;
    
    constructor() { }
    ngOnInit() {
        this.prefillData = this.prefillData || {};
        this.question.value = this.question.value.length > 10 ? this.question.value.substring(0,10) : this.question.value;
        this.isLeadFormApplication = constants.IS_LEAD_FORM_APPLICATION;
    }


    checkInput(question) {

        //let invalidChars = /(^\s+|\s+$)/g;
        let invalidChars = /[^0-9]/gi;
        if (invalidChars.test(question.value) || parseInt(question.value) == 0) {
            if (parseInt(question.value) == 0) {
                question.value = "";
            }
            else {
                question.value = question.value.replace(invalidChars, "");
                if (parseInt(question.value) == 0) {
                    question.value = "";
                }
            }
        }
        else if((question.value+'').match(/^0/)) {
            question.value = (question.value+'').replace(/^0+/g, '');
        }
    }

    phonInit() {

        let ele: any = $(this.phInput.nativeElement);
        let intelInputExist = ele.find('.main-input').css('padding-left', '100px !important').intlTelInput;

        // if(!this.isLoaded){
        ele.find('.main-input').css('padding-left', '100px !important').intlTelInput();
        if (ele.find('.country_flag_code').length == 0) {
            ele.find('.intl-tel-input .selected-flag .iti-arrow').after('<span class="country_flag_code"></span>');
            // if (window.navigator.userAgent.indexOf("Chrome") !== -1) {
            //     ele.find('.intl-tel-input .selected-flag .iti-arrow').after('<span class="country_flag_code"></span>');
            // } else {
            //     ele.find('.intl-tel-input .selected-flag .iti-arrow').after('<span class="country_flag_code"></span>');
            // }
        }
        ele.find('input').on("countrychange", (e, countryData) => {
            ele.find('.country_flag_code').html('+' + countryData.dialCode);
            this.phoneCodeModel = countryData.dialCode;
            this.form.value.field[this.question['code']] = countryData.dialCode;
        });

        // let phCode = this.prefillData[this.question['code']] || '971';
        let phCode = this.prefillData[this.question['code']] || '971';
        let phValue = this.question.value || '';
        if (!this.form.value.field[this.question['code']]) {
            
            this.phoneCodeModel = this.prefillData[this.question['code']] || '971';
           
            this.form.value.field[this.question['code']] = phCode;
        }
        phValue && ele.find('.main-input').intlTelInput("setNumber", "+"+phCode+phValue);
        ele.find('.country_flag_code').html('+' + phCode);
        // }
    };

}

@Directive({ selector: '[after-if]' })
export class AfterIfDirective {
    @Output('after-if')
    public after: EventEmitter<AfterIfDirective> = new EventEmitter();

    public constructor() {
        setTimeout(() => {
            // timeout helps prevent unexpected change errors
            this.after.next(this);
        });
    }
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/phone/phone.component.ts